<template>
  <b-row>
    <b-col>
      <table class="table table-sm table-responsive-md table-grid table-hover">
        <thead>
        <tr>
          <th class="w-50">{{$t('views.exsborder.form.positions.item')}}</th>
          <th>{{$t('views.exsborder.form.positions.quantity')}}</th>
          <th class="m-2">{{$t('views.exsborder.form.positions.measure')}}</th>
          <th class="w-50">{{$t('views.exsborder.form.positions.notes')}}</th>
          <th class="w-2"></th>
        </tr>
        </thead>
        <tbody v-for="(position, positionIndex) in data.value" v-bind:key="'customField-' + positionIndex">
          <td>
            <base-select-input
              class="w-100"
              :id="'position_item_'+positionIndex"
              v-model="position.idItem"
              :search-callback="itemSearchCallback"
              :query-param="'name'"
              :display-values="['name']"
              :is-auto-complete-mode="true"
              base-endpoint="e_x_s_b_items"
              @input="handleSelectItem($event, positionIndex)"
            ></base-select-input>
          </td>
          <td>
            <el-input-number
              :id="'position_quantity_'+positionIndex"
              v-model="position.quantity"
              :min="1">
            </el-input-number>
          </td>
          <td>
            <div class="ml-2 mt-2" v-if="position.measureName">
              {{ position.measureName }}
            </div>
          </td>
          <td>
            <el-input
              :id="'position_notes_'+positionIndex"
              v-model="position.notes">
            </el-input>
          </td>
          <td>
            <button
              type="button"
              class="btn btn-link fa fa-trash fa-lg"
              @click="removeItemCollection(positionIndex)"
              v-b-tooltip.hover :title="$t('buttons.delete')">
            </button>
          </td>
        </tbody>
      </table>
      <b-row>
        <b-col cols="3">
          <b-btn @click="addNewItemCollection()">{{$t('views.exsborder.form.addNewPosition')}}</b-btn>
        </b-col>
        <b-col cols="9" v-if="!addPositionsFromCsvEnabled">
          <b-btn class="float-right" @click="addPositionsFromCsv()">{{$t('views.exsborder.form.addPositionsFromCsv')}}</b-btn>
        </b-col>
        <b-col cols="9" v-if="addPositionsFromCsvEnabled">
          <b-row>
            <b-col cols="8">
              <b-form-file class="float-right" browse-text="Przeglądaj" ref="file-input" name="document" accept=".csv" v-model="dataFile" :state="Boolean(document)" :placeholder="'Przeciągnij i upuść plik lub kliknij przeglądaj'"></b-form-file>
            </b-col>
            <b-col>
              <b-btn class="float-right" @click="addPositionsFromCsvAction()">{{$t('views.exsborder.form.addPositionsFromCsvAction')}}</b-btn>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-alert class="mt-2" v-if="addPositionsFromCsvSuccess" show variant="info">{{$t('views.exsborder.form.positionsInCustomFieldsLoadedSuccess')}}</b-alert>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>

import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'itemsCollectionCustomField',
  components: { BaseSelectInput },
  props: {
    data: {}
  },
  data () {
    return {
      addPositionsFromCsvEnabled: false,
      addPositionsFromCsvSuccess: false,
      dataFile: ''
    }
  },
  methods: {
    addNewItemCollection () {
      if (this.data.value === null || this.data.value === undefined) {
        this.data.value = []
      }
      let objectGD = {
        idItem: null,
        name: '',
        quantity: 1,
        notes: '',
        measureName: ''
      }
      this.data.value.push(objectGD)
    },
    addPositionsFromCsv () {
      this.addPositionsFromCsvEnabled = true
    },
    addPositionsFromCsvAction () {
      let formData = new FormData()
      formData.append('dataFile', this.dataFile)
      this.$http.post('api/prepare_custom_field_from_file',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        if (response.status === 200) {
          this.$Swal({
            type: 'success',
            title: this.$t('notifications.store.savedTitle'),
            timer: 2500
          })
          this.data.value = response.data
          this.addPositionsFromCsvSuccess = true
          this.item.addPositionsFromCsvSuccess = true
          this.$forceUpdate()
        } else if (response.status === 207) {
          let text = ''
          for (let i in response.data) {
            text += response.data[i] + '\n'
          }
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
      }).catch(error => {
        if (error.response.status === 400) {
          let text = error.response.data['hydra:description']
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
        console.log(error)
      })
    },
    async removeItemCollection (itemIndex) {
      this.data.value.splice(itemIndex, 1)
    },
    async handleSelectItem (id, positionIndex) {
      let position = this.data.value[positionIndex]
      if (!id || id === 'null') {
        position.name = ''
        position.measureName = ''
        this.$forceUpdate()
        return
      }
      id = getId(id)
      let item = await new ApiService(`e_x_s_b_items/${id}`).getResults()
      if (item) {
        position.name = item.name
        if (item.measure) {
          position.measureName = item.measure.name
        }
      }
      this.$forceUpdate()
    },
    async itemSearchCallback (params = {}) {
      let baseParams = { pagination: false, state: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_items', baseParams).getResults()
      return response.items.map(entry => {
        entry['@id'] = getId(entry['@id'])
        return entry
      })
    }
  }
}
</script>
